import { gapFillerClient } from './apiClients'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { InsuranceTypeOptions } from 'src/config/insuranceTypeOptions'

export interface GapFillerSurvey {
  patientType: PatientTypeOptions
  treatmentBundleReferenceId: string
  phoneNumber: string
  clinicReferenceId: string
  insuranceType?: InsuranceTypeOptions
  preferredPractitionerReferenceId?: string
  patientReferenceId?: string
}

export const postGapFillerSurvey = async (gapFillerSurvey: GapFillerSurvey) => {
  return gapFillerClient.post('/patients/missed-patient', gapFillerSurvey)
}
